module.exports={
	"Form": "MaterialViewManifest",
	"Scope": "Material-View",
	"Descriptors":
	{
		"MaterialDetails.Name":
		{
			"Name": "Name",
			"Hash": "Material-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "Material-View-Identity",
				"Group": "Material-View-Identity"
			}
		},
		"MaterialDetails.NameAbbreviated":
		{
			"Name": "Name Abbreviated",
			"Hash": "Material-View-NameAbbreviated",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "Material-View-Identity",
				"Group": "Material-View-Identity"
			}
		},
		"MaterialDetails.CatalogCode":
		{
			"Name": "Catalog Code",
			"Hash": "Material-View-CatalogCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "Material-View-Identity",
				"Group": "Material-View-Identity"
			}
		},
		"MaterialDetails.MaterialCode":
		{
			"Name": "Material Code",
			"Hash": "Material-View-MaterialCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "Material-View-Identity",
				"Group": "Material-View-Identity"
			}
		},
		"MaterialDetails.ItemCode":
		{
			"Name": "Item Code",
			"Hash": "Material-View-ItemCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "Material-View-Identity",
				"Group": "Material-View-Identity"
			}
		},
		"MaterialDetails.Type":
		{
			"Name": "Type",
			"Hash": "Material-View-Type",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "Material-View-Details",
				"Group": "Material-View-Details"
			}
		},
		"MaterialDetails.Description":
		{
			"Name": "Description",
			"Hash": "Material-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 12,
				"Section": "Material-View-Details",
				"Group": "Material-View-Details"
			}
		},
		"MaterialDetails.UnitsMetric":
		{
			"Name": "Units Metric",
			"Hash": "Material-View-UnitsMetric",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Material-View-Details",
				"Group": "Material-View-Details"
			}
		},
		"MaterialDetails.UnitsImperial":
		{
			"Name": "Units Imperial",
			"Hash": "Material-View-UnitsImperial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Material-View-Details",
				"Group": "Material-View-Details"
			}
		},
		"MaterialDetails.Active":
		{
			"Name": "Active",
			"Hash": "Material-View-Active",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "Material-View-Details",
				"Group": "Material-View-Details"
			}
		},
		"MaterialDetails.BrandNameRequired":
		{
			"Name": "Brand Name Required",
			"Hash": "Material-View-BrandNameRequired",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "6",
				"Width": 3,
				"Section": "Material-View-Details",
				"Group": "Material-View-Details"
			}
		},
		"MaterialDetails.IDMaterialParent":
		{
			"Name": "Parent Material",
			"Hash": "Material-View-IDMaterialParent",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "6",
				"Width": 4,
				"Section": "Material-View-Details",
				"Group": "Material-View-Details",
				"Entity": "Material",
				"SearchFields":
				[
					"Name",
					"MaterialCode",
					"ItemCode"
				],
				"ReadOnly": true
			}
		},
		"MaterialDetails.Category":
		{
			"Name": "Category",
			"Hash": "Material-View-Category",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Material-View-Details",
				"Group": "Material-View-Details"
			}
		},
		"MaterialDetails.CategoryName":
		{
			"Name": "Category Name",
			"Hash": "Material-View-CategoryName",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Material-View-Details",
				"Group": "Material-View-Details"
			}
		},
		"MaterialDetails.ItemSection":
		{
			"Name": "Item Section",
			"Hash": "Material-View-ItemSection",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Material-View-Details",
				"Group": "Material-View-Details"
			}
		},
		"MaterialDetails.IDMaterial":
		{
			"Name": "IDMaterial",
			"Hash": "Material-View-IDMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Material-View-DataAudit",
				"Group": "Material-View-DataAudit"
			}
		},
		"MaterialDetails.GUIDMaterial":
		{
			"Name": "GUIDMaterial",
			"Hash": "Material-View-GUIDMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Material-View-DataAudit",
				"Group": "Material-View-DataAudit"
			}
		},
		"MaterialDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Material-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Material-View-DataAudit",
				"Group": "Material-View-DataAudit"
			}
		},
		"MaterialDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Material-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "Material-View-DataAudit",
				"Group": "Material-View-DataAudit"
			}
		},
		"MaterialDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Material-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "Material-View-DataAudit",
				"Group": "Material-View-DataAudit"
			}
		},
		"MaterialDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Material-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "Material-View-DataAudit",
				"Group": "Material-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Material-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Material-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Material-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Material-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Material-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Material-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
